module.exports = __webpack_public_path__ + "img/ch4-emissions.2f85ca40.png";